// Mobile: Akkordeon für horizontale Navigationsleiste
function initNavBarAccordion() {
  const navBarItems = document.querySelectorAll('.menu-list--mobile .menu-list__list li');
  if (navBarItems.length === 0) return;

  navBarItems.forEach(function(item) {
    const link = item.querySelector('a');
    if (!link) return;

    const linkHandle = link.id ? link.id.replace('MenuItem-', '') : '';
    if (!linkHandle) return;

    const childLinks = document.querySelectorAll('[id^="HeaderDrawer-' + linkHandle + '-"]');
    if (childLinks.length === 0) return;

    if (!item.querySelector('.nav-arrow')) {
      const arrow = document.createElement('span');
      arrow.className = 'nav-arrow';
      arrow.innerHTML = ' ▾';
      link.appendChild(arrow);
    }

    if (item.querySelector('.custom-submenu')) return;

    const submenu = document.createElement('ul');
    submenu.className = 'custom-submenu';
    submenu.style.display = 'none';
    submenu.style.listStyle = 'none';
    submenu.style.padding = '8px 0';
    submenu.style.margin = '0';
    submenu.style.background = '#ffffff';
    submenu.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
    submenu.style.position = 'fixed';
    submenu.style.zIndex = '99999';
    submenu.style.minWidth = '200px';

    childLinks.forEach(function(childEl) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = childEl.href || '#';
      const textEl = childEl.querySelector('.menu-drawer__menu-item-text') || childEl;
      a.textContent = textEl.textContent.trim();
      a.style.display = 'block';
      a.style.padding = '12px 20px';
      a.style.color = '#000000';
      a.style.textDecoration = 'none';
      a.style.fontSize = '15px';
      a.style.borderBottom = '1px solid rgba(0,0,0,0.06)';
      li.appendChild(a);
      submenu.appendChild(li);
    });

    document.body.appendChild(submenu);

    function openSubmenu() {
      document.querySelectorAll('.custom-submenu').forEach(function(s) { s.style.display = 'none'; });
      const linkRect = link.getBoundingClientRect();
      let leftPos = linkRect.left;
      if (leftPos + 200 > window.innerWidth) leftPos = window.innerWidth - 210;
      submenu.style.top = linkRect.bottom + 'px';
      submenu.style.left = leftPos + 'px';
      submenu.style.display = 'block';
    }

    link.addEventListener('touchend', function(e) {
      e.preventDefault(); e.stopImmediatePropagation();
      submenu.style.display === 'block' ? submenu.style.display = 'none' : openSubmenu();
    }, { capture: true });

    link.addEventListener('click', function(e) {
      e.preventDefault(); e.stopImmediatePropagation();
      submenu.style.display === 'block' ? submenu.style.display = 'none' : openSubmenu();
    }, { capture: true });
  });

  document.addEventListener('touchend', function(e) {
    if (!e.target.closest('.menu-list--mobile') && !e.target.closest('.custom-submenu')) {
      document.querySelectorAll('.custom-submenu').forEach(function(s) { s.style.display = 'none'; });
    }
  });
}

// Desktop: Hover öffnet Dropdown, Pfeil absolut positioniert
function initDesktopNav() {
  if ('ontouchstart' in window) return;

  const desktopLinks = document.querySelectorAll('header-menu .menu-list__link[aria-haspopup="true"]');
  if (desktopLinks.length === 0) return;

  desktopLinks.forEach(function(link) {
    // Pfeil absolut unter dem Link
    if (!link.querySelector('.desktop-arrow')) {
      const arrow = document.createElement('span');
      arrow.className = 'desktop-arrow';
      arrow.textContent = '▾';
      arrow.style.cssText = 'position:absolute; bottom:24px; left:50%; transform:translateX(-50%); font-size:16px; line-height:1; pointer-events:none; color:#ff0000; transition:transform 0.2s ease, color 0.2s ease;';
      link.style.position = 'relative';
      link.appendChild(arrow);

      link.addEventListener('mouseenter', function() {
        arrow.style.transform = 'translateX(-50%) translateY(3px)';
        arrow.style.color = '#cc0000';
      });
      link.addEventListener('mouseleave', function() {
        arrow.style.transform = 'translateX(-50%) translateY(0)';
        arrow.style.color = '#ff0000';
      });
    }

    // Submenü-Links aus aria-controls holen
    const submenuId = link.getAttribute('aria-controls');
    if (!submenuId) return;
    const themeSubmenu = document.getElementById(submenuId);
    if (!themeSubmenu) return;
    const subLinks = themeSubmenu.querySelectorAll('a');
    if (subLinks.length === 0) return;

    if (link._desktopDropdown) return;
    const dropdown = document.createElement('ul');
    dropdown.style.cssText = 'display:none; list-style:none; padding:8px 0; margin:0; background:#fff; box-shadow:0 4px 12px rgba(0,0,0,0.2); position:fixed; z-index:99999; min-width:220px; border-radius:4px;';

    subLinks.forEach(function(subLink) {
      const text = subLink.textContent.trim();
      if (!text) return;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = subLink.href || '#';
      a.textContent = text;
      a.style.cssText = 'display:block; padding:12px 20px; color:#000; text-decoration:none; font-size:15px; border-bottom:1px solid rgba(0,0,0,0.06);';
      a.addEventListener('mouseenter', function() { a.style.background = '#f5f5f5'; });
      a.addEventListener('mouseleave', function() { a.style.background = 'transparent'; });
      li.appendChild(a);
      dropdown.appendChild(li);
    });

    document.body.appendChild(dropdown);
    link._desktopDropdown = dropdown;

    let closeTimer = null;

    function openDropdown() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      desktopLinks.forEach(function(l) {
        if (l._desktopDropdown && l !== link) l._desktopDropdown.style.display = 'none';
      });
      const rect = link.getBoundingClientRect();
      let left = rect.left;
      if (left + 220 > window.innerWidth) left = window.innerWidth - 230;
      dropdown.style.top = rect.bottom + 'px';
      dropdown.style.left = left + 'px';
      dropdown.style.display = 'block';
    }

    function closeDropdown() {
      closeTimer = setTimeout(function() {
        dropdown.style.display = 'none';
      }, 200);
    }

    // Hover auf Link
    link.addEventListener('mouseenter', openDropdown);
    link.addEventListener('mouseleave', closeDropdown);

    // Hover auf Dropdown – offen lassen
    dropdown.addEventListener('mouseenter', function() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });
    dropdown.addEventListener('mouseleave', closeDropdown);

    // Klick auch noch möglich
    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dropdown.style.display === 'block' ? dropdown.style.display = 'none' : openDropdown();
    }, { capture: true });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('header-menu') && !e.target.closest('ul[style*="z-index:99999"]')) {
      desktopLinks.forEach(function(l) {
        if (l._desktopDropdown) l._desktopDropdown.style.display = 'none';
      });
    }
  });
}

// Kollektionstitel "Produkte" auf /collections/all zu "Artikel" ändern
if (window.location.pathname === '/collections/all') {
  window.addEventListener('load', function() {
    document.querySelectorAll('h1').forEach(function(el) {
      if (el.textContent.trim() === 'Produkte') el.textContent = 'Artikel';
    });
  });
}

window.addEventListener('load', function() {
  setTimeout(initNavBarAccordion, 1000);
  setTimeout(initNavBarAccordion, 2000);
  setTimeout(initDesktopNav, 1000);
});
// Laufband nur für die Shop-Ankündigungszeile
(function() {
  function isShopAnnouncement(banner) {
    var text = (
      banner.textContent ||
      banner.innerText ||
      ''
    ).trim();

    return /Shop[- ]?Eröffnung|Shop[- ]?Opening|AUSSER|EXCLUDING|LIQUID CHEMICALS/i.test(text);
  }

  function initAnnouncementMarquee() {
    document.querySelectorAll('.announcement-bar__text').forEach(function(banner) {
      // Andere Header-Zeilen nicht verändern
      if (!isShopAnnouncement(banner)) {
        return;
      }

      if (banner.dataset.marqueeReady === 'true') {
        return;
      }

      var originalContent = banner.innerHTML.trim();

      if (!originalContent) {
        return;
      }

      // Flüssig-Chemie-Hinweis rot hervorheben
      originalContent = originalContent.replace(
        /(\(?\s*AUSSER\s+FLÜSSIG-CHEMIE(?:&nbsp;|\s)*(?:!)?\s*\)?)/gi,
        '<strong class="announcement-warning">$1</strong>'
      );

      banner.dataset.marqueeReady = 'true';
      banner.classList.add('announcement-marquee-ready');

      banner.innerHTML = `
        <span class="announcement-marquee-track">
          <span class="announcement-marquee-item">
            ${originalContent}
          </span>
          <span class="announcement-marquee-item" aria-hidden="true">
            ${originalContent}
          </span>
        </span>
      `;
    });
  }

  var style = document.createElement('style');

  style.textContent = `
    .announcement-bar__text.announcement-marquee-ready {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow-x: hidden !important;
      overflow-y: visible !important;
      white-space: nowrap !important;
      line-height: 1.5 !important;
      padding: 3px 0 5px !important;
      box-sizing: border-box !important;
    }

    .announcement-bar__text.announcement-marquee-ready
    .announcement-warning {
      display: inline-block !important;
      color: #FF4500 !important;
      font-weight: 900 !important;
      white-space: nowrap !important;
      line-height: 1.5 !important;
    }

    .announcement-bar__text.announcement-marquee-ready
    .announcement-marquee-track {
      display: inline-flex !important;
      width: max-content !important;
      max-width: none !important;
      white-space: nowrap !important;
      line-height: 1.5 !important;
      animation: announcement-marquee 30s linear infinite;
      will-change: transform;
    }

    .announcement-bar__text.announcement-marquee-ready
    .announcement-marquee-item {
      display: inline-block !important;
      flex: 0 0 auto !important;
      white-space: nowrap !important;
      line-height: 1.5 !important;
      padding-right: 80px;
    }

    @keyframes announcement-marquee {
      0% {
        transform: translate3d(0, 0, 0);
      }

      100% {
        transform: translate3d(-50%, 0, 0);
      }
    }

    @media screen and (max-width: 749px) {
      .announcement-bar__text.announcement-marquee-ready {
        line-height: 1.5 !important;
        padding: 3px 0 5px !important;
      }

      .announcement-bar__text.announcement-marquee-ready
      .announcement-marquee-track {
        animation-duration: 24s;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .announcement-bar__text.announcement-marquee-ready
      .announcement-marquee-track {
        animation: none;
        transform: none;
      }
    }
  `;

  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAnnouncementMarquee
    );
  } else {
    initAnnouncementMarquee();
  }

  window.addEventListener(
    'load',
    initAnnouncementMarquee
  );
})();


// Einheitliche Sprachauswahl für Handy und PC
(function() {
  var selector = '#header-component .dropdown-localization';
  var flagClass = 'custom-language-flag';
  var updatePending = false;

  function isVisible(element) {
    return !!(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length
    );
  }

  function findTarget(root) {
    var elements = root.querySelectorAll(
      'button, summary, select, [role="button"]'
    );

    for (var i = 0; i < elements.length; i++) {
      if (isVisible(elements[i])) {
        return elements[i];
      }
    }

    return root;
  }

  function getLanguage(target) {
    var pageLanguage = (
      document.documentElement.getAttribute('lang') || ''
    ).toLowerCase();

    if (pageLanguage.indexOf('en') === 0) {
      return 'EN';
    }

    if (pageLanguage.indexOf('de') === 0) {
      return 'DE';
    }

    var text = (target.textContent || '').toLowerCase();

    return /english|englisch|\ben\b/.test(text) ? 'EN' : 'DE';
  }

  function getFlagSvg(language) {
    // Handy: Emoji-Fahnen
    if (window.matchMedia('(max-width: 749px)').matches) {
      return language === 'EN' ? '🇬🇧' : '🇩🇪';
    }

    // PC: deutsche Flagge
    if (language === 'DE') {
      return `
        <svg viewBox="0 0 60 40" aria-hidden="true">
          <rect width="60" height="13.33" fill="#000000"/>
          <rect y="13.33" width="60" height="13.33" fill="#DD0000"/>
          <rect y="26.66" width="60" height="13.34" fill="#FFCE00"/>
        </svg>
      `;
    }

    // PC: englische Flagge
    return `
      <svg viewBox="0 0 60 40" aria-hidden="true">
        <rect width="60" height="40" fill="#012169"/>
        <path d="M0 0 L60 40 M60 0 L0 40"
              stroke="#ffffff" stroke-width="10"/>
        <path d="M0 0 L60 40 M60 0 L0 40"
              stroke="#C8102E" stroke-width="4"/>
        <path d="M30 0 V40 M0 20 H60"
              stroke="#ffffff" stroke-width="16"/>
        <path d="M30 0 V40 M0 20 H60"
              stroke="#C8102E" stroke-width="8"/>
      </svg>
    `;
  }

  function shortenLanguage(root) {
    if (!root) {
      return;
    }

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    var textNodes = [];
    var node;

    while (node = walker.nextNode()) {
      if (
        node.parentElement &&
        !node.parentElement.closest(
          '.custom-language-flag, svg, .svg-wrapper'
        )
      ) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(function(textNode) {
      var currentText = textNode.nodeValue.trim();
      var replacement = null;

      if (/^(Deutsch|German|DE)$/i.test(currentText)) {
        replacement = 'DE';
      }

      if (/^(English|Englisch|EN)$/i.test(currentText)) {
        replacement = 'EN';
      }

      if (replacement && currentText !== replacement) {
        textNode.nodeValue = textNode.nodeValue.replace(
          currentText,
          replacement
        );
      }
    });
  }

  function updateLanguageSelector() {
    updatePending = false;

    document.querySelectorAll(selector).forEach(function(root) {
      var target = findTarget(root);
      var language = getLanguage(target);
      var flag = root.querySelector('.' + flagClass);

      if (!flag) {
        flag = document.createElement('span');
        flag.className = flagClass;
        flag.setAttribute('aria-hidden', 'true');

        if (target === root) {
          root.insertBefore(flag, root.firstChild);
        } else if (target.parentNode) {
          target.parentNode.insertBefore(flag, target);
        }
      }

      var flagMode = window.matchMedia('(max-width: 749px)').matches
        ? 'mobile'
        : 'desktop';

      var flagKey = language + '-' + flagMode;

      if (flag.getAttribute('data-flag-key') !== flagKey) {
        flag.innerHTML = getFlagSvg(language);
        flag.setAttribute('data-language', language);
        flag.setAttribute('data-flag-key', flagKey);
      }

      shortenLanguage(root);
    });
  }

  function scheduleUpdate() {
    if (updatePending) {
      return;
    }

    updatePending = true;

    setTimeout(function() {
      updateLanguageSelector();
    }, 50);
  }

  var style = document.createElement('style');

  style.textContent = `
    #header-component .dropdown-localization {
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      text-align: left !important;
      flex-direction: row !important;
      gap: 6px;
    }

    #header-component .custom-language-flag {
      display: inline-flex !important;
      width: auto !important;
      height: auto !important;
      min-width: 20px;
      flex: 0 0 auto !important;
      margin: 0 6px 0 0 !important;
      line-height: 1 !important;
      vertical-align: middle;
      position: relative;
      z-index: 5;
      font-family:
        "Apple Color Emoji",
        "Segoe UI Emoji",
        "Noto Color Emoji",
        sans-serif;
      font-size: 1.15em;
    }

    #header-component .custom-language-flag svg {
      display: block;
      width: 20px;
      height: 14px;
      border-radius: 2px;
      transform: skewX(-4deg);
    }

    @media screen and (max-width: 749px) {
      #header-component .header__row--top {
        position: relative;
      }

      #header-component .header__row--top .dropdown-localization {
        position: absolute !important;
        top: calc(100% + 2px);
        transform: translateY(-30px);
        right: 16px;
        z-index: 20;
        grid-area: auto !important;
      }
    }

    @media screen and (min-width: 750px) {
      #header-component .dropdown-localization {
        position: static !important;
        top: auto !important;
        right: auto !important;
        transform: none !important;
      }
    }
  `;

  document.head.appendChild(style);

  updateLanguageSelector();

  document.addEventListener(
    'DOMContentLoaded',
    updateLanguageSelector
  );

  new MutationObserver(scheduleUpdate).observe(document.body, {
    childList: true,
    subtree: true
  });
})();